module.exports = __webpack_public_path__ + "static/media/icon-google-play--black.1cfdf55d.png";